export const convertToNumber = (value: string): number => {
  if (value === undefined) {
    return 0;
  } else {
    try {
      const i = value.replace(/[^0-9.]/g, "");
      return +i;
    } catch (e) {
      return 0;
    }
  }
};
